import { c as _c } from "react/compiler-runtime";
import styled, { css } from 'styled-components';
import generateNumberFromString from '../../../utils/generateRandomNumberFromString';
import { Span, StyledUtilsProps } from '../helpers/StyledUtils';
const chart_colors = ['#99B8F5', '#7991C2', '#596B8F', '#A899F5', '#8579C2', '#62598F', '#D699F5', '#AA79C2', '#7D598F', '#F599E6', '#C279B6', '#8F5986', '#F599B8', '#C27991', '#8F596B', '#F5A899', '#C28579', '#8F6259', '#E6F599', '#B6C279', '#868F59', '#B8F599', '#91C279', '#6B8F59', '#99F5D6', '#79C2AA', '#598F7D', '#99E6F5', '#79B6C2', '#59868F', '#F5D699', '#C2AA79', '#8F7D59', '#99F5A8', '#79C285', '#598F62'];
export const generateRandomChartColor = (str: string) => {
  return chart_colors[generateNumberFromString(str, 0, chart_colors.length - 1)];
};
interface Props extends StyledUtilsProps {
  id?: string;
  color?: string;
}
const StyledDot = styled(Span)<{
  color: string;
}>(({
  color
}) => css`
    background-color: ${color};
    border-radius: 50%;
    height: 8px;
    width: 8px;
    display: inline-block;
  `);
const LegendColor = t0 => {
  const $ = _c(10);
  let color;
  let id;
  let other_props;
  if ($[0] !== t0) {
    ({
      id,
      color,
      ...other_props
    } = t0);
    $[0] = t0;
    $[1] = color;
    $[2] = id;
    $[3] = other_props;
  } else {
    color = $[1];
    id = $[2];
    other_props = $[3];
  }
  let t1;
  if ($[4] !== color || $[5] !== id) {
    t1 = color || generateRandomChartColor(id || "1");
    $[4] = color;
    $[5] = id;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const _color = t1;
  let t2;
  if ($[7] !== _color || $[8] !== other_props) {
    t2 = <StyledDot color={_color} {...other_props} />;
    $[7] = _color;
    $[8] = other_props;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  return t2;
};
export default LegendColor;